import {
  IconSunHigh,
  IconCloud,
  IconCloudBolt,
  IconCloudRain,
  IconCloudSnow,
  IconSnowflake,
  IconSun,
  IconWind,
} from '@tabler/icons-react';
import React from 'react';

import {
  WeatherCurrentConditionsDtoWeatherCondition,
  WeatherCurrentConditionsDtoWeatherConditionTypeEnum,
} from 'src/Services/API/generated';

const map = {
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.TypeUnspecified]: React.Fragment,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Clear]: IconSunHigh,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.MostlyClear]: IconSun,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.PartlyCloudy]: IconSun,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.MostlyCloudy]: IconCloud,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Cloudy]: IconCloud,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Windy]: IconWind,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.WindAndRain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightRainShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ChanceOfShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ScatteredShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.RainShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavyRainShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightToModerateRain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ModerateToHeavyRain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Rain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightRain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavyRain]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.RainPeriodicallyHeavy]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightSnowShowers]: IconCloudSnow,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ChanceOfSnowShowers]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ScatteredSnowShowers]: IconCloudSnow,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.SnowShowers]: IconCloudSnow,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavySnowShowers]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightToModerateSnow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ModerateToHeavySnow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Snow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightSnow]: IconCloudSnow,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavySnow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Snowstorm]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.SnowPeriodicallyHeavy]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavySnowStorm]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.BlowingSnow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.RainAndSnow]: IconSnowflake,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Hail]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HailShowers]: IconCloudRain,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Thunderstorm]: IconCloudBolt,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.Thundershower]: IconCloudBolt,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.LightThunderstormRain]: IconCloudBolt,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.ScatteredThunderstorms]: IconCloudBolt,
  [WeatherCurrentConditionsDtoWeatherConditionTypeEnum.HeavyThunderstorm]: IconCloudBolt,
} as Record<WeatherCurrentConditionsDtoWeatherConditionTypeEnum, typeof IconSunHigh>;

export function weatherConditionToIcon(condition: WeatherCurrentConditionsDtoWeatherCondition) {
  const icon = map[condition.type];

  if (!icon) return React.Fragment;

  return icon;
}
